<template>
  <div class="inline-block w-full">
    <div :class="['w-full h-[4.1rem] relative rounded-md bg-neutral-50 text-left']">
      <input
        :id="finalId"
        :type="type"
        :name="name"
        :value="props.modelValue === 0 ? null : props.modelValue"
        :class="[' rounded-md border border-neutral-200 focus:outline-hidden focus:border-petrol-500 focus:ring-1 focus:ring-petrol-500 absolute w-full bg-transparent text-left pt-7 pb-2 px-3 block font-semibold text-lg z-10', { 'focus-placeholder-hidden': focus.status }]"
        :placeholder="focus.status ? '' : props.placeholder"
        @input="handleTextInputDebounced"
        @focus="focus.status = true"
        @blur="focus.status = false"
      >
      <label
        v-if="$slots.label"
        :for="finalId"
        :class="['left-0 top-0 text-center mt-1 ml-3 absolute']"
      >
        <slot name="label" />
      </label>
      <div v-if="$slots.value" :class="['left-0 top-0 border border-transparent text-left pt-7 pb-2 px-3 block font-semibold text-lg z-5']">
        <slot name="value" />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
const props = defineProps({
  id: {
    type: String,
    default: null
  },
  placeholder: {
    type: String,
    default: ' '
  },
  name: {
    type: String,
    default: ''
  },
  type: {
    type: String,
    default: 'text'
  },
  modelValue: {
    type: [Number],
    default: 0
  },
  error: {
    type: Boolean,
    default: false
  }
})

const generatedId = useComponentId('input-price')
const finalId = computed(() => props.id ?? generatedId)

const emit = defineEmits(['update:modelValue'])

const focus = reactive({
  status: false
})

let debouncingTimerId = null
function handleTextInputDebounced (event) {
  const inputValue = event.target.value
  const numericValue = inputValue.replace(/\D/g, '')
  event.target.value = numericValue

  if (debouncingTimerId !== null) {
    clearTimeout(debouncingTimerId)
  }
  debouncingTimerId = setTimeout(() => {
    if (numericValue === '') {
      emit('update:modelValue', 0)
      return
    }
    emit('update:modelValue', Number(numericValue))
  }, 500)
}

</script>
<style scoped>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
}
input[type="number"] {
  -moz-appearance: textfield;
  vertical-align: baseline;
}
</style>
